import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import TechlinkItemShowFactory from './TechlinkItemShowFactory'
import TechlinkCompanyIndex from './TechlinkCompanyIndex/TechlinkCompanyIndex'
import TechlinkFirstJobIndex from './TechlinkFirstJobIndex/TechlinkFirstJobIndex'
import TechlinkInternshipIndex from './TechlinkInternshipIndex/TechlinkInternshipIndex'
import TechlinkStudentJobIndex from './TechlinkStudentJobIndex/TechlinkStudentJobIndex'

const TechlinkRouter = (props) => {
    const { intl, user } = props
    const { formatMessage } = intl

    return (
        <Switch>
            <Route exact path={`/techlink/${formatMessage({ id: 'routes.companies' })}`}>
                <TechlinkCompanyIndex {...props}/>
            </Route>
            <Route exact path={`/techlink/${formatMessage({ id: 'routes.first-jobs' })}`}>
                <TechlinkFirstJobIndex {...props}/>
            </Route>
            <Route exact path={`/techlink/${formatMessage({ id: 'routes.internships' })}`}>
                <TechlinkInternshipIndex {...props}/>
            </Route>
            <Route exact path={`/techlink/${formatMessage({ id: 'routes.student-jobs' })}`}>
                <TechlinkStudentJobIndex {...props}/>
            </Route>
            <Route
                path={`/techlink/${formatMessage({ id: 'routes.companies' })}/:itemid/`}
                render={(props) => <>
                    <TechlinkItemShowFactory
                        {...props}
                        renderType='company'
                        getAllInfoUrl='/api/v1/companies/get_all_info?id='
                        user={user}
                    />
                </>
                }
            />
            <Route
                path={`/techlink/${formatMessage({ id: 'routes.first-jobs' })}/:itemid/`}
                render={(props) => <>
                    <TechlinkItemShowFactory
                        {...props}
                        renderType='job'
                        getAllInfoUrl='/api/v1/first_jobs/get_all_info?id='
                        user={user}
                    />
                </>
                }
            />
            <Route
                path={`/techlink/${formatMessage({ id: 'routes.internships' })}/:itemid/`}
                render={(props) => <>
                    <TechlinkItemShowFactory
                        {...props}
                        renderType='job'
                        getAllInfoUrl='/api/v1/internships/get_all_info?id='
                        user={user}
                    />
                </>
                }
            />
            <Route
                path={`/techlink/${formatMessage({ id: 'routes.student-jobs' })}/:itemid/`}
                render={(props) => <>
                    <TechlinkItemShowFactory
                        {...props}
                        renderType='job'
                        getAllInfoUrl='/api/v1/student_jobs/get_all_info?id='
                        user={user}
                    />
                </>
                }
            />
        </Switch>
    )
}

export default injectIntl(TechlinkRouter)
